import { Button, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
const InvoiceModal = (props) => {
    const { openModal, setOpenmodel, invoiceList, setInvoiceListForModal } = props;
    const handleClose = () => { setOpenmodel(false); setInvoiceListForModal([]) };
    return (
        <>
            <Dialog maxWidth={"lg"} fullWidth open={openModal} onClose={handleClose}>
                <DialogContent className='p-0'>
                    <Stack direction={"row"} gap={3} px={3} py={2.5} className='align-items-center'>
                        <Typography className='text-capitalie' variant='h4' component="h4" style={{ textTransform: "capitalize" }}>Download Invoices</Typography>
                    </Stack>
                    <hr />
                    {
                        invoiceList?.map((item) => (
                            <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} sx={{ padding: '20px', width: '100%',borderBottom:'1px solid #F0F0F0' }}>
                                <Typography sx={{ textTransform: 'capitalize' }}>{item?.name || "Invoice"}</Typography>
                                <Button className="downloadCSV" startIcon={<FileDownloadOutlinedIcon fontSize="small" />} onClick={() => {
                                    if (item.location) {
                                        setTimeout(() => {
                                            window.open(item.location, "_blank");
                                        }, 500);
                                    }
                                }}>Download</Button>
                            </Stack>
                        ))
                    }
                </DialogContent >
            </Dialog >
        </>
    );
};
export default InvoiceModal;